import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SalesPhoneRegisterComponent} from "./sales-phone-register.component";
import {
  SalesPhoneRegisterManualGeneralInstructionsComponent
} from "./manual/general-instructions/sales-phone-register-manual-general-instructions.component";
import {
  SalesPhoneRegisterManualIntroduceImeiComponent
} from "./manual/introduce-imei/sales-phone-register-manual-introduce-imei.component";
import {
  SalesPhoneRegisterManualImeiInstructionsComponent
} from "./manual/imei-instructions/sales-phone-register-manual-imei-instructions.component";
import {
  SalesPhoneRegisterEngineComponent
} from "../phone-register-engine/sales-phone-register-engine.component";
import {
  SalesPhoneRegisterEngineErrorMessageComponent
} from "../phone-register-engine/error-message/sales-phone-register-engine-error-message.component";
import {PrimengModule} from "../../shared/primeng-module/primeng.module";
import {GeneralModule} from "../general/general.module";
import {ReactiveFormsModule} from "@angular/forms";



@NgModule({
  declarations: [
    SalesPhoneRegisterComponent,
    SalesPhoneRegisterManualGeneralInstructionsComponent,
    SalesPhoneRegisterManualIntroduceImeiComponent,
    SalesPhoneRegisterManualImeiInstructionsComponent,
    SalesPhoneRegisterEngineComponent,
    SalesPhoneRegisterEngineErrorMessageComponent
  ],
  imports: [
    CommonModule,
    PrimengModule,
    GeneralModule,
    ReactiveFormsModule,
  ],
  exports: [
    SalesPhoneRegisterComponent
  ]
})
export class SalesPhoneRegisterModule { }
